import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useQueryClient } from 'react-query'
import styled from 'styled-components'

import { getAreaList } from '@/api/login'
import { isOpenHK } from '@/api/login'
import LogoImg from '@/assets/images/1v1_logo_v2.png'
import UserBgImg from '@/assets/images/user_bg.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import { centerStore, deviceInfoStore, globalStore, loginStore, useRecoilValue, useResetRecoilState, useSetRecoilState } from '@/store'
import { getParams } from '@/utils/tool'
import { getVisitorId } from '@/utils/tool'

import { normalizeMobileInput } from './utils'

import Forget from './components/Forget'
import Password from './components/Password'
import Register from './components/Register'
import Sms from './components/Sms'

const { stepState, stepTxtState, areaListState, mobileState, areaState, needSliderState } = loginStore
const { addProWxWinState } = globalStore
const { userState } = centerStore
const { deviceShowState } = deviceInfoStore

export default function Index() {
  const step = useRecoilValue(stepState)
  const stepTxt = useRecoilValue(stepTxtState)
  const setAreaList = useSetRecoilState(areaListState)
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const setAddProWxWin = useSetRecoilState(addProWxWinState)
  const setMobileState = useSetRecoilState(mobileState)
  const setAreaState = useSetRecoilState(areaState)
  const setStep = useSetRecoilState(stepState)
  const setNeedSliderState = useSetRecoilState(needSliderState)
  const queryClient = useQueryClient()
  const resetUser = useResetRecoilState(userState)

  useEffect(() => {
    queryClient.clear()
    resetUser()
    setDeviceShow(false)
    setAddProWxWin(false)

    getVisitorId()
    const { t, area, s } = getParams(location.search)
    const nextArea = area ? `+${area}` : '+86'
    area && setAreaState(nextArea)
    t && setMobileState(normalizeMobileInput(t, nextArea))
    if (s === 'register') {
      setStep(2)
    }
  }, [])

  const { data } = useQuery(['getAreaList'], getAreaList)
  useEffect(() => {
    if (data) {
      const { data: area } = data
      setAreaList(area)
    }
  }, [data])

  // 是否需要滑块验证
  useEffect(() => {
    isOpenHK().then((res: any) => {
      // 1需要 0不需要
      if (res.data.isOpenHK) {
        setNeedSliderState(true)
      }
    })
  }, [])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className="w-screen h-screen flex flex-col">
      <Header className="w-full h-[80px] bg-white m-0 p-0 z-10">
        <div className="h-full w-[1200px] ml-auto mr-auto flex justify-center items-center">
          <div className=" h-full flex justify-center items-center">
            <a className=" block h-[57px]" href="/">
              <ImgPlaceholder className=" h-full w-auto" src={LogoImg} alt="logo" />
            </a>
          </div>
          <div className="title">{stepTxt}</div>
        </div>
      </Header>
      <Center className="flex-1 flex justify-center items-center w-full">
        <div className="flex-[2] h-full user-bg"></div>
        <div className="flex-1 h-full flex items-center">
          <AnimatePresence exitBeforeEnter>
            <motion.div key={step} initial={{ y: 5, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 5, opacity: 0 }} transition={{ duration: 0.2 }}>
              {step === 0 ? <Sms /> : null}
              {step === 1 ? <Password /> : null}
              {step === 2 ? <Register /> : null}
              {step === 3 ? <Forget /> : null}
            </motion.div>
          </AnimatePresence>
        </div>
      </Center>
    </Container>
  )
}

const Container = styled(motion.div)``
const Center = styled(motion.div)`
  .user-bg {
    background-image: url('${UserBgImg}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
  }
`
const Header = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  .title {
    flex: 1;
    font-size: 24px;
    color: #4d4d4d;
    position: relative;
    padding-left: 20px;
    margin-left: 20px;
    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -10px;
      width: 2px;
      height: 20px;
      background: #e5e5e5;
    }
  }
`
